import { isBrowser } from '~/shared/utils/platform';

export default function getUrl(path: string) {
    return new URL(
        (isBrowser ? '/shop-api/proxy/v1' : '/api/v1') + path,
        isBrowser ? window.location.origin : process.env.SHOP_API_URL,
    );
}
